<template>
  <div
    class="modal fade"
    id="testDisabled"
    tabindex="-1"
    role="dialog"
    aria-labelledby="testDisabled"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{$t("nts.ams.fe.testbo.warning.testdisable.title")}}</h3>
        </div>
        <div class="modal-body">
          <p v-html="$t('nts.ams.fe.testbo.warning.testdisable.body1')"></p>
          <p v-html="$t('nts.ams.fe.testbo.warning.testdisable.body2', { company_tel: this.telephone })"></p>
          <p v-html="$t('nts.ams.fe.testbo.warning.testdisable.body3')"></p>
        </div>
        <div class="modal-footer">
          <center><button class="btn btn-success" @click="ok()">{{$t("btn.mypage")}}</button></center>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";

export default {
    name: "TestDisabledModal",
    data() {
      return {
        telephone: ""
      }
    },
    mounted() {
        this.openTestDisabledModal();
    },
    methods: {
        openTestDisabledModal() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_TEST_DISABLED_MODAL, (params) => {
                  this.telephone = params.telephone;
                  $('#testDisabled').modal({backdrop: 'static', keyboard: false});
                  this.show();
            });
        },

        ok() {
            $('#testDisabled').modal("hide");
            this.$modal.closeTestDisabledModal();
        },

        show() {
            $('#testDisabled').modal("show");
        }
    },

}
</script>

<style scoped>

</style>
